import { AbilitySubject, every, not } from "@cdv/jazz-auth";
import { User } from "../../api";
import { isAppuser } from "../utils";

export default function defineTestVersionAbility(can: AbilitySubject<User>): void {
  can(["update", "create"], not(isAppuser));
}
